import React from 'react';
import { createPortal } from 'react-dom';
import './ContactNavigateConfirmDialog.css';

export interface ContactNavigateConfirmDialogProps {
  isOpen: boolean;
  onSaveAndContinue: () => void;
  onContinue: () => void;
  onCancel: () => void;
  saving?: boolean;
}

const ContactNavigateConfirmDialog: React.FC<ContactNavigateConfirmDialogProps> = ({
  isOpen,
  onSaveAndContinue,
  onContinue,
  onCancel,
  saving = false
}) => {
  if (!isOpen) return null;

  return createPortal(
    <div
      className="contact-navigate-dialog-overlay"
      role="presentation"
      onClick={onCancel}
    >
      <div
        className="contact-navigate-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="contact-navigate-dialog-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="contact-navigate-dialog-header">
          <h3 id="contact-navigate-dialog-title">Unsaved changes</h3>
        </div>
        <div className="contact-navigate-dialog-body">
          <p>This contact has unsaved edits. What would you like to do?</p>
        </div>
        <div className="contact-navigate-dialog-footer">
          <button
            type="button"
            className="app-btn app-btn-secondary"
            onClick={onCancel}
            disabled={saving}
          >
            Cancel
          </button>
          <button
            type="button"
            className="app-btn app-btn-secondary"
            onClick={onContinue}
            disabled={saving}
          >
            Continue
          </button>
          <button
            type="button"
            className="app-btn app-btn-primary"
            onClick={onSaveAndContinue}
            disabled={saving}
          >
            {saving ? 'Saving...' : 'Save and Continue'}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ContactNavigateConfirmDialog;
